module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image26.ea81c566.jpg";